import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GoogleAnalyticsService } from '../../../../services/google-analytics/google-analytics.service';

export interface Acuerdo {
  idAgreement: number;
  pending: number;
  installment: number;
  value: number;
  expiration: Date;
  paid: number;
  payable: number;
  selected?: boolean;
  montoAPagar?: number;
  minimumAmmount?: number;
  agreementInformation?: {
    policyNumber: string;
    documentNumber: number;
  }[];
  paymentAvailable?: boolean;
}

@Component({
  selector: 'app-modal-acuerdos',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    @if (isVisible) {
    <div class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <div class="title-container">
            <h4 class="title-h4-blue">
              {{ clientName }}
            </h4>
            <h6>Acuerdos de Pago</h6>
          </div>
          <div class="search-container">
            <label>Filtrar por</label>
            <input
              type="text"
              class="input-field"
              [(ngModel)]="filterText"
              (ngModelChange)="onFilterTextChange()"
            />
          </div>
        </div>

        <table class="facturas-table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  [checked]="allSelected"
                  (change)="toggleSelectAll()"
                />
              </th>
              <th (click)="ordenar('idAgreement')">
                No. Acuerdo
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'idAgreement' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'idAgreement' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('pending')">
                Balance Pendiente
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'pending' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'pending' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('installment')">
                Cuota
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'installment' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'installment' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('value')">
                Valor Cuota
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'value' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'value' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('minimumAmmount')">
                Mínimo a Pagar
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'minimumAmmount' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'minimumAmmount' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('expiration')">
                Vencimiento
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'expiration' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'expiration' && sortDesc
                  }"
                ></i>
              </th>
              <th (click)="ordenar('paid')">
                Pagadas
                <i
                  class="bi"
                  [ngClass]="{
                    'bi-arrow-up': sortColumn === 'paid' && !sortDesc,
                    'bi-arrow-down': sortColumn === 'paid' && sortDesc
                  }"
                ></i>
              </th>
              <th>Monto a Pagar DOP</th>
            </tr>
          </thead>
          <tbody>
            @for (acuerdo of paginatedData; track acuerdo.idAgreement + '-' +
            $index; let i = $index) {
            <tr [class]="getEstiloError(acuerdo)">
              <td>
                <input
                  type="checkbox"
                  [checked]="acuerdo.selected"
                  (change)="toggleSelect(acuerdo)"
                  [disabled]="acuerdo.paid === 1"
                />
              </td>
              <td>{{ acuerdo.idAgreement }}</td>
              <td>{{ acuerdo.pending | currency : '$' }}</td>
              <td>{{ acuerdo.installment }}</td>
              <td>{{ acuerdo.value | currency : '$' }}</td>
              <td>{{ acuerdo.minimumAmmount | currency : '$' }}</td>
              <td>{{ acuerdo.expiration | date : 'dd/MM/yyyy' }}</td>
              <td>{{ acuerdo.paid === 1 ? 'Sí' : 'No' }}</td>
              <td>
                <input
                  type="number"
                  [ngModel]="acuerdo.selected ? acuerdo.value : undefined"
                  [disabled]="true"
                  class="input-field"
                  readonly
                />
              </td>
            </tr>
            }
          </tbody>
        </table>

        <div class="pagination-container">
          <button
            class="page-link"
            [disabled]="currentPage === 1"
            (click)="onPageChange(currentPage - 1)"
          >
            anterior
          </button>

          <ul class="pagination">
            <li class="page-item" [class.active]="currentPage === 1">
              <a class="page-link" (click)="onPageChange(1)">1</a>
            </li>

            @if (currentPage > 3 && totalPages > 5) {
            <li class="page-item">
              <span class="page-link">...</span>
            </li>
            } @for (page of getVisiblePages(); track page) {
            <li class="page-item" [class.active]="currentPage === page">
              <a class="page-link" (click)="onPageChange(page)">{{ page }}</a>
            </li>
            } @if (currentPage < totalPages - 2 && totalPages > 5) {
            <li class="page-item">
              <span class="page-link">...</span>
            </li>
            } @if (totalPages > 1) {
            <li class="page-item" [class.active]="currentPage === totalPages">
              <a class="page-link" (click)="onPageChange(totalPages)">{{
                totalPages
              }}</a>
            </li>
            }
          </ul>

          <button
            class="page-link"
            [disabled]="currentPage === totalPages"
            (click)="onPageChange(currentPage + 1)"
          >
            siguiente
          </button>
        </div>

        <div class="modal-footer">
          <div class="total">
            Total a pagar: {{ totalAPagar | currency : 'DOP ' }}
          </div>
          <div class="actions">
            <button class="btn-cerrar" (click)="cerrarModal()">Cerrar</button>
            <button
              class="btn-agregar"
              [disabled]="!hayAcuerdosSeleccionados()"
              (click)="agregarAcuerdos()"
            >
              Agregar
            </button>
          </div>
        </div>
      </div>
    </div>
    }
  `,
  styles: [
    `
      .error-row {
        background-color: rgba(255, 0, 0, 0.05) !important;

        td {
          border-color: #ff4444;
        }

        input.invalid-input {
          border: 2px solid #ff4444;
          background-color: #fff5f5;
        }
      }

      .invalid-input {
        border: 2px solid #ff4444;
        background-color: #fff5f5;
      }

      .title-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        backdrop-filter: blur(10px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
      }

      .search-container {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-bottom: 1rem;
      }

      .search-container label {
        color: #00558c;
        font-weight: 500;
        font-size: 14px;
      }

      .search-container .input-field {
        flex: 1;
        padding: 0.5rem;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        font-size: 14px;
      }

      .search-container .input-field:focus {
        outline: none;
        border-color: #0099dc;
      }

      .modal-content {
        background: white;
        border-radius: 12px;
        padding: 2rem;
        width: 90%;
        max-width: 1200px;
        max-height: 90vh;
        overflow-y: auto;
      }

      .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 2rem;
      }

      .modal-header h2 {
        color: #00558c;
        margin: 0;
        font-size: 1.5rem;
      }

      .facturas-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 2rem;
      }

      .facturas-table th,
      .facturas-table td {
        color: #00558c;
        padding: 0.35rem;
        text-align: left;
        border-bottom: 1px solid #e8e8e8;
        font-size: 12px;
      }

      .facturas-table th {
        background-color: #f8f9fa;
        color: #00558c;
        font-weight: 500;
      }

      .facturas-table input {
        width: 100%;
        padding: 0.5rem;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
      }

      .invalid-input {
        background-color: #f3f4f6;
        border: 1px solid #ff9e1b;
        outline: none;
      }

      .modal-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 2rem;
        padding-top: 1rem;
        border-top: 1px solid #e8e8e8;
      }

      .total {
        color: #00558c;
        font-weight: 600;
        font-size: 1.1rem;
      }

      .actions {
        display: flex;
        gap: 1rem;
      }

      .btn-cerrar,
      .btn-agregar {
        padding: 0.5rem 2rem;
        border-radius: 4px;
        border: none;
        cursor: pointer;
        font-weight: 500;
        transition: all 0.3s ease;
      }

      .btn-cerrar {
        background-color: #f8f9fa;
        color: #6c757d;
      }

      .btn-cerrar:hover {
        background-color: #e2e6ea;
      }

      .btn-agregar {
        background-color: #0099dc;
        color: white;
      }

      .btn-agregar:hover {
        background-color: #0088c5;
      }

      .btn-agregar:disabled {
        background-color: #e9ecef;
        color: #6c757d;
        cursor: not-allowed;
      }

      .pagination-container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 0.5rem;
      }

      .pagination {
        display: flex;
        list-style: none;
        margin: 0;
        padding: 0;
        gap: 0.25rem;
      }

      .page-item {
        margin: 0 1px;
      }

      .page-link {
        padding: 4px 8px;
        border: none;
        background: none;
        color: #00558c !important;
        cursor: pointer;
        border-radius: 4px;
        font-weight: 500;
        font-size: 12px;
        transition: all 0.3s ease;
      }

      .page-item.active .page-link {
        background-color: #00558c;
        color: white !important;
      }

      button.page-link {
        background-color: #f8f9fa;
        color: #00558c;
        font-size: 11px;
        padding: 4px 6px;
        border: none;
      }

      button.page-link:disabled {
        background-color: #e9ecef;
        color: #9ea6be !important;

        cursor: not-allowed;
      }

      .page-link:hover:not(:disabled) {
        background-color: #e9ecef;
      }

      .title-container h6 {
        color: #00558c;
        margin: 0;
      }

      /* Estilos responsivos */
      @media screen and (max-width: 1040px) {
        .modal-content {
          padding: 1rem;
          width: 95%;
        }

        .facturas-table {
          font-size: 12px;
        }

        .facturas-table th,
        .facturas-table td {
          padding: 0.5rem;
        }

        .btn-cerrar,
        .btn-agregar {
          padding: 0.5rem 1rem;
        }

        .pagination-container {
          padding: 0.5rem;
        }

        .pagination {
          font-size: 10px;
        }

        .page-link {
          padding: 3px 6px;
        }

        button.page-link {
          font-size: 10px;
        }
      }

      @media screen and (max-width: 768px) {
        .pagination-container {
          flex-direction: row;
          justify-content: center;
        }
      }
    `,
  ],
})
export class ModalAcuerdosComponent {
  @Input() isVisible: boolean = false;
  @Input() acuerdos: Acuerdo[] = [];
  @Input() clientName: string = '';

  @Output() cerrar = new EventEmitter<void>();
  @Output() agregar = new EventEmitter<Acuerdo[]>();

  totalAPagar: number = 0;
  acuerdosData: Acuerdo[] = [];

  itemsPerPage: number = 6;
  currentPage: number = 1;
  totalPages: number = 0;
  paginatedData: Acuerdo[] = [];

  sortColumn: string | null = null;
  sortDesc: boolean = false;
  allSelected: boolean = false;

  filterText: string = '';

  constructor(private gAnalytics:GoogleAnalyticsService) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['acuerdos'] && changes['acuerdos'].currentValue) {
      this.acuerdosData = [...changes['acuerdos'].currentValue];
      this.updatePagination();
      this.calcularTotal();
    }
  }

  updatePagination() {
    this.totalPages = Math.ceil(this.acuerdosData.length / this.itemsPerPage);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedData = this.acuerdosData.slice(startIndex, endIndex);
  }

  onPageChange(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePagination();
      this.gAnalytics.trackEvent('click_paginacion',{
      page:'/pagos-online',
      action:'Paginacion en tabla de acuerdos'
    })
    }
  }

  getVisiblePages(): number[] {
    const delta = 2;
    const range: number[] = [];
    const seen = new Set<number>();

    for (
      let i = Math.max(2, this.currentPage - delta);
      i <= Math.min(this.totalPages - 1, this.currentPage + delta);
      i++
    ) {
      if (!seen.has(i)) {
        seen.add(i);
        range.push(i);
      }
    }

    return range;
  }

  ordenar(columna: keyof Acuerdo) {
    if (this.sortColumn === columna) {
      this.sortDesc = !this.sortDesc;
    } else {
      this.sortColumn = columna;
      this.sortDesc = false;
    }

    this.acuerdosData.sort((a, b) => {
      let valorA = a[columna];
      let valorB = b[columna];

      if (valorA === null || valorA === undefined)
        return this.sortDesc ? -1 : 1;
      if (valorB === null || valorB === undefined)
        return this.sortDesc ? 1 : -1;

      if (typeof valorA === 'number' && typeof valorB === 'number') {
        return this.sortDesc ? valorB - valorA : valorA - valorB;
      }

      const strA = String(valorA).toLowerCase();
      const strB = String(valorB).toLowerCase();

      return this.sortDesc
        ? strB.localeCompare(strA)
        : strA.localeCompare(strB);
    });

    this.updatePagination();
  }

  toggleSelectAll() {

    this.gAnalytics.trackEvent('seleccionar_todos_acuerdos',{
      page:'/pagos-online',
      action:'Seleccionar todos los acuerdos'
    })

    this.allSelected = !this.allSelected;
    this.acuerdosData.forEach((acuerdo) => {
      if (acuerdo.paid !== 1) {
        acuerdo.selected = this.allSelected;
        if (acuerdo.selected) {
          acuerdo.montoAPagar = acuerdo.value;
        } else {
          acuerdo.montoAPagar = undefined;
        }
      }
    });
    this.calcularTotal();
    this.updatePagination();
  }

  toggleSelect(acuerdo: Acuerdo) {

     this.gAnalytics.trackEvent('seleccionar_acuerdo',{
      page:'/pagos-online',
      action:'Seleccionar acuerdo individual en el modal de acuerdos',
    })


    if (acuerdo.paid === 1) {
      return;
    }
    acuerdo.selected = !acuerdo.selected;
    if (acuerdo.selected) {
      acuerdo.montoAPagar = acuerdo.value;
    } else {
      acuerdo.montoAPagar = undefined;
    }
    this.checkAllSelected();
    this.calcularTotal();
  }

  onMontoChange(index: number, monto: number) {
    if (
      this.acuerdosData[index] &&
      this.isMontoValido(this.acuerdosData[index], monto)
    ) {
      this.acuerdosData[index].montoAPagar = monto;
      this.calcularTotal();
    }
  }

  isMontoValido(acuerdo: Acuerdo, monto: number): boolean {
    return acuerdo && monto >= acuerdo.value && monto <= acuerdo.pending;
  }

  calcularTotal() {
    this.totalAPagar = this.acuerdosData.reduce(
      (sum, acuerdo) => sum + (acuerdo.montoAPagar || 0),
      0
    );
  }

  hayAcuerdosSeleccionados(): boolean {
    const todasLasAcuerdosValidas = this.acuerdosData
      .filter((a) => a.selected)
      .every((a) => this.isMontoValido(a, a.montoAPagar || 0));

    const hayAlgunaSeleccionada = this.acuerdosData.some((f) => f.selected);

    return hayAlgunaSeleccionada && todasLasAcuerdosValidas;
  }

  isFilaDeshabilitada(acuerdo: Acuerdo): boolean {
    return true;
  }

  cerrarModal() {
    this.cerrar.emit();
  }

  agregarAcuerdos() {
    const acuerdosSeleccionados = this.acuerdosData.filter(
      (a) => a.selected && a.montoAPagar && a.paid === 0
    );

    this.gAnalytics.trackEvent('agregar_acuerdo',{
      page:'/pagos-online',
      action:'Agregar acuerdo'
    })

    this.agregar.emit(acuerdosSeleccionados);
  }

  getEstiloError(acuerdo: Acuerdo): string {
    if (!acuerdo.selected) return '';

    return !this.isMontoValido(acuerdo, acuerdo.montoAPagar || 0)
      ? 'error-row'
      : '';
  }

  onFilterTextChange() {
    if (!this.filterText.trim()) {
      this.acuerdosData = [...this.acuerdos];
    } else {
      const searchText = this.filterText.toLowerCase();
      this.acuerdosData = this.acuerdos.filter(
        (acuerdo) =>
          acuerdo.agreementInformation?.some((info) =>
            info.policyNumber.toLowerCase().includes(searchText)
          ) || acuerdo.idAgreement.toString().includes(searchText)
      );
    }
    this.currentPage = 1;
    this.updatePagination();
  }

  checkAllSelected() {
    const acuerdosSeleccionables = this.acuerdosData.filter(
      (acuerdo) => acuerdo.paid !== 1
    );
    this.allSelected =
      acuerdosSeleccionables.length > 0 &&
      acuerdosSeleccionables.every((acuerdo) => acuerdo.selected);
  }
}
